/* globals cc */

var TweenPico = require('../util/TweenPico');
var Browser = require('../util/Browser');

function VideoHandler(videoNodes, config, eventEmitter, sizmekApi, messagingApi) {

	this.videoPlayAsked;
	this.config = config;
	this.event = eventEmitter;
	this.messaging = messagingApi;
	this.canplayFired = false;

	this.initVideo = function(video, videoControls) {

		console.log(' [init video] : ', video, videoControls);

		var play = videoControls.play;
		var pause = videoControls.pause;
		var sound = videoControls.sound;
		var mute = videoControls.mute;

		video.preload = 'auto';

		var _this = this;
		if (play && pause) {
			video.addEventListener('playing', function() {
				if (video.id === 'video') {
					_this.messaging.dispatchMessage('startVideo');
					_this.event.emit('VIDEO_PLAY', this);
				} else {
					_this.messaging.dispatchMessage('startVideoExpand');
					_this.event.emit('VIDEO_EXPAND_PLAY', this);
				}

				play.style.display = 'none';
				pause.style.opacity = 0;
				pause.style.display = 'block';
				TweenPico.to(pause, 0.3, {
					opacity: 1
				});
			});

			video.addEventListener('pause', function() {
				pause.style.display = 'none';
				play.style.opacity = 0;
				play.style.display = 'block';
				TweenPico.to(play, 0.3, {
					opacity: 1
				});
			});
		}

		if (sound && mute) {
			video.addEventListener('volumechange', function() {
				if (video.volume === 0) {
					sound.style.display = 'none';
					mute.style.opacity = 0;
					mute.style.display = 'block';
					TweenPico.to(mute, 0.3, {
						opacity: 1
					});
				} else {
					mute.style.display = 'none';
					sound.style.opacity = 0;
					sound.style.display = 'block';
					TweenPico.to(sound, 0.3, {
						opacity: 1
					});
				}
			});
		}

		video.addEventListener('ended', this.onVideoEnd.bind(this));

		video.addEventListener('canplay', function() {
			if (_this.videoPlayAsked) {
				console.log('canplay > videoPlayAsked > ' + _this.videoPlayAsked.id);
				_this.canplayFired = true;
				_this.startVideo(_this.videoPlayAsked);
			} else {
				console.log('canplay fired');
			}
		});

		if (pause) pause.addEventListener('click', function(e) {
			e.stopPropagation();
			video.pause();
		});

		if (play) play.addEventListener('click', function(e) {
			e.stopPropagation();
			video.play();
		});

		if (sound) sound.addEventListener('click', function(e) {
			e.stopPropagation();
			video.volume = 0;
		});

		if (mute) mute.addEventListener('click', function(e) {
			e.stopPropagation();
			video.volume = 1;
		});

	};

	this.onVideoEnd = function(e) {

		if (e.target.id === 'video') {
			if (cc.replay) cc.replay.style.display = 'block';

			//REMOVE for responsive banner
			//ADD for all
			if (cc.expand) cc.expand.style.display = 'none';

			//debug for IE9
			TweenPico.to(cc.videoWrapper, 0.25, {
				opacity: 0,
				onComplete: function() {
					cc.videoWrapper.style.display = 'none';
				}
			});

			//TODO homogéniser les events name
			this.messaging.dispatchMessage('endVideo');

			console.log('   [event] Ad::VIDEO_END ');
			this.event.emit('VIDEO_END', this);
		} else {

			TweenPico.to(cc.videoExpandWrapper, 0.25, {
				opacity: 0
			});

			//TODO homogéniser les events name
			this.messaging.dispatchMessage('endVideoExpand');

			console.log('   [event] Ad::VIDEO_EXPAND_END ');
			this.event.emit('VIDEO_EXPAND_END', this);

		}
	};

	this.startVideo = function(video, videoFadeInDelay) {
		if (video) {
			console.log('   > startVideo, video.readyState : ', video.readyState, ' isIE9 : ', Browser.isIE9);

			var vWrapper = (video.id === 'video') ? cc.videoWrapper : cc.videoExpandWrapper;

			if (vWrapper) {
				vWrapper.style.display = 'block';
				vWrapper.style.opacity = 0;
			}

			if (videoFadeInDelay === 0 || this.config.videoAlpha === 0) {
				if (vWrapper) vWrapper.style.opacity = 1;
			} else {
				TweenPico.to(vWrapper, videoFadeInDelay || this.config.videoAlpha || 0, {
					opacity: 1
				});
			}

			video.controls = false;

			//TODO : tcheck sur ipad readyState === 2
			//ADD : || video.readyState === 3 > IE11 wallpaper
			//REMOVE : || video.readyState === 3 > IE9 bug sur http://sistyle.ch/
			//ADD : || video.readyState === 3 > if !isIE9
			//REMOVE : || video.readyState === 3 > if !isIE9
			//ADD : || video.readyState === 3 > IE11 & IE9 pushdown 20min
			//ADD : || video.readyState === 3 > if !isIE9 > wallpaper columbia
			//REMOVE : || (video.readyState === 3 && !Browser.isIE9) > expand konbini sous ie9

			if (video.readyState === 4 || video.readyState === 2 || video.readyState === 3 || this.canplayFired) {
				this.canplayFired = true;
				this.videoPlayAsked = false;
				video.currentTime = 0; //IE check
				video.play();
				video.volume = 0.1; //dirty tricks pour que le bouton mute s'affiche dans tout les cas
				if (video.id === 'videoExpand' && this.config.defaultSoundOnExpand) {
					video.volume = this.config.defaultSoundOnExpand;
				} else {
					video.volume = 0;
				}
			} else {
				if (video.readyState === 1) { //HAVE_METADATA
					video.controls = true; //ajout des controls pour pouvoir cliquer sur le play
				}

				console.log('   > startVideo > videoPlayAsked (standby)');
				this.videoPlayAsked = video;
			}
		} else {
			console.log('[warning] ad.startVideo : video argument is undefined');
		}
	};

	this.onExpand = function() {
		if (this.config.defaultSoundOnExpand && cc.videoExpand) cc.videoExpand.volume = this.config.defaultSoundOnExpand;
		if (cc.video && !this.config.preventVideoPauseOnExpand) cc.video.pause();

		//TODO : conditionner , test du currentBordel...
		// l'idée est juste de le declencher sur ipad/tablette pour le cas des formats sans tempo
		if (cc.videoExpand && Browser.isIOS) cc.videoExpand.play();
	};

	this.onCollapse = function() {
		if (cc.videoExpand) cc.videoExpand.pause();
	};

	//initialisation du tracking vidéo et des controls
	var video;
	for (var i = 0; i < videoNodes.length; i++) {
		video = videoNodes[i];
		if (!video) continue;

		var childNodes = video.parentNode.childNodes;
		var id;

		//pour que les controls soient indentifier, il doivent être :
		//dans le même wrapper que la vidéo
		//contenir un des mots clés suivant :
		var videoControls = {
			play: null,
			pause: null,
			sound: null,
			mute: null
		};

		for (var element in childNodes) {
			id = childNodes[element].id;
			if (id && id !== video.id) {
				for (var prop in videoControls) {
					if (id.match(new RegExp(prop))) {
						videoControls[prop] = childNodes[element];
						break;
					}
				}
			}
		}

		sizmekApi.initVideo(video);
		this.initVideo(video, videoControls);
	}

	this.event.on('EXPAND_AD', this.onExpand.bind(this));
	this.event.on('COLLAPSE_AD', this.onCollapse.bind(this));

}

module.exports = VideoHandler;
